/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
// eslint-disable-next-line
import React from 'react'

export const Hide = ({ condition, useDisplay, useOpacity, noSpace, children }) => {
  let hiddenStyle = 'visibility: hidden;'
  if (useDisplay) {
    hiddenStyle = 'display: none;'
  } else if (useOpacity) {
    hiddenStyle = 'opacity: 0;'
  }
  const style = css`
    ${!!condition ? hiddenStyle : ''}
    &, & * {
      ${!!condition && noSpace ? 'position: absolute; width: 200px; z-index: -100; top: -500; left: -500' : ''}
    }
  `

  return <div css={style}>{children}</div>
}
